"use client";

import { createContext, useContext, type ReactNode } from "react";

type AuthUXState = {
  isStaff: boolean; // For showing/hiding UI elements only
  userRole?: string;
  userName?: string;
};

const AuthUXContext = createContext<AuthUXState | null>(null);

export function AuthUXProvider({
  children,
  isStaff,
  userRole,
  userName,
}: {
  children: ReactNode;
  isStaff: boolean;
  userRole?: string;
  userName?: string;
}) {
  return (
    <AuthUXContext.Provider value={{ isStaff, userRole, userName }}>
      {children}
    </AuthUXContext.Provider>
  );
}

export function useAuthUX() {
  const context = useContext(AuthUXContext);
  if (!context) {
    throw new Error("useAuthUX must be used within AuthUXProvider");
  }
  return context;
}
